export const CIP = 'CIP'
export const FCA = 'FCA'
export const MIX = 'MIX'
